var _typeof=require("@babel/runtime/helpers/typeof");;(function(root,factory,undef){if((typeof exports==="undefined"?"undefined":_typeof(exports))==="object"){// CommonJS
module.exports=exports=factory(require("./core"),require("./cipher-core"));}else if(typeof define==="function"&&define.amd){// AMD
define(["./core","./cipher-core"],factory);}else{// Global (browser)
factory(root.CryptoJS);}})(this,function(CryptoJS){/**
	 * Zero padding strategy.
	 */CryptoJS.pad.ZeroPadding={pad:function pad(data,blockSize){// Shortcut
var blockSizeBytes=blockSize*4;// Pad
data.clamp();data.sigBytes+=blockSizeBytes-(data.sigBytes%blockSizeBytes||blockSizeBytes);},unpad:function unpad(data){// Shortcut
var dataWords=data.words;// Unpad
var i=data.sigBytes-1;while(!(dataWords[i>>>2]>>>24-i%4*8&0xff)){i--;}data.sigBytes=i+1;}};return CryptoJS.pad.ZeroPadding;});